export interface ChartTheme {
  backgroundColor: string;
  gridColor: string;
  textColor: string;
  tooltipBackgroundColor: string;
  tooltipTextColor: string;
  tooltipBorderColor: string;
}

export function getChartTheme(isDark: boolean): ChartTheme {
  if (isDark) {
    return {
      backgroundColor: 'transparent', // No noticeable background for charts
      gridColor: 'hsl(215 27.9% 16.9%)', // --border from CSS variables  
      textColor: 'hsl(0 0% 98%)', // --foreground from CSS variables
      tooltipBackgroundColor: 'hsl(215 27.9% 16.9%)', // --muted from CSS variables
      tooltipTextColor: 'hsl(0 0% 98%)', // --foreground from CSS variables
      tooltipBorderColor: 'hsl(215 20.2% 65.1%)', // --muted-foreground from CSS variables
    };
  } else {
    return {
      backgroundColor: 'transparent', // No noticeable background for charts
      gridColor: 'hsl(215 20.2% 65.1%)', // --border from CSS variables
      textColor: 'hsl(222.2 84% 4.9%)', // --foreground from CSS variables
      tooltipBackgroundColor: 'hsl(210 40% 98%)', // --muted from CSS variables
      tooltipTextColor: 'hsl(222.2 84% 4.9%)', // --foreground from CSS variables
      tooltipBorderColor: 'hsl(215 20.2% 65.1%)', // --muted-foreground from CSS variables
    };
  }
}

// Chart.js configuration for dark mode
export function getChartJsOptions(isDark: boolean, formatCurrency: (value: string | number) => string) {
  const theme = getChartTheme(isDark);
  
  return {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 0,
    },
    plugins: {
      legend: {
        labels: {
          color: theme.textColor,
        },
      },
      tooltip: {
        backgroundColor: theme.tooltipBackgroundColor,
        titleColor: theme.tooltipTextColor,
        bodyColor: theme.tooltipTextColor,
        borderColor: theme.tooltipBorderColor,
        borderWidth: 1,
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += formatCurrency(context.parsed.y);
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          color: theme.gridColor,
          display: true,
        },
        ticks: {
          color: theme.textColor,
          font: {
            size: 14
          }
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: theme.gridColor,
        },
        ticks: {
          color: theme.textColor,
          callback: formatCurrency,
          font: {
            size: 16,
          }
        }
      },
    },
  };
}

